import script from "./PastBooking.vue?vue&type=script&lang=ts&setup=true"
export * from "./PastBooking.vue?vue&type=script&lang=ts&setup=true"

import "./PastBooking.vue?vue&type=style&index=0&id=f6022960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6022960"]])

export default __exports__